<template>
  <el-popover width="350" trigger="hover" popper-class="goods-popover" :append-to-body="true" @show="getGoods">
    <div class="goods-wrap" v-loading="loading" style="min-height:100px">
      <div class="goods-wrap-title" v-if="waitDeliver.length">
        {{ $t('stores::order::wait') }}
      </div>
      <div class="goods-wrap-list" v-if="waitDeliver.length">
        <template v-for="item in waitDeliver">
          <div class="goods-wrap-item" :key="item.id">
            <div style="position: relative">
              <el-badge :value="Number(item.skuNum) || 0" type="info">
                <el-image style="width: 50px; height: 50px" :src="item.skuIcon"></el-image>
              </el-badge>
            </div>
            <div class="goods-item-info">
              <p class="more-line">{{ item.spuName }}</p>
              <p>{{ item.skuAttr }}</p>
              <p>SKU {{ $dataCheck(item.skuId) }}</p>
            </div>
          </div>
        </template>
      </div>
      <div class="goods-wrap-title" v-if="finishDeliver.length">
        {{ $t('stores::order::shipping') }}
      </div>
      <div class="goods-wrap-list" v-if="finishDeliver.length">
        <template v-for="item in finishDeliver">
          <div class="goods-wrap-item" :key="item.id">
            <div style="position: relative">
              <el-badge :value="Number(item.skuNum) || 0" type="info">
                <el-image style="width: 50px; height: 50px" :src="item.skuIcon"></el-image>
              </el-badge>
            </div>
            <div class="goods-item-info">
              <p class="more-line">{{ $dataCheck(item.spuName) }}</p>
              <p>{{ item.skuAttr }}</p>
              <p>SKU {{ $dataCheck(item.skuId) }}</p>
            </div>
          </div>
        </template>
      </div>
    </div>
    <el-button style="padding: 5px" v-show="row.product" slot="reference">
      ...
    </el-button>
  </el-popover>
</template>

<script>
import { filterVariant } from '@/utils/utils'
import { getOrderAnalysisGoodsList } from '@/server/etl'
export default {
  name: 'order-goods',
  props: {
    row: {
      type: Object,
      default: () => {}
    },
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      waitDeliver: [],
      finishDeliver: []
    }
  },
  computed: {
    list() {
      return (this.row.productByConditionDto && this.row.productByConditionDto.productList) || []
    }
  },
  mounted() {},
  methods: {
    filterVariant,
    async getGoods() {
      this.waitDeliver = []
      this.finishDeliver = []
      this.loading = true
      const { data } = await getOrderAnalysisGoodsList({ ...this.config, orderNo: this.row.orderNo })
      this.loading = false
      if (data.code === this.$code) {
        data.data.datas.forEach(el => {
          if (el.orderSubFulfillmentStatus === '待发货' || el.orderSubFulfillmentStatus === '待处理') {
            this.waitDeliver.push(el)
          } else {
            this.finishDeliver.push(el)
          }
        })
        console.log(this.waitDeliver)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-wrap {
  max-height: 350px;
  overflow: auto;
  .goods-wrap-title {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .goods-wrap-item {
    display: flex;
    .goods-item-info {
      margin-left: 20px;
    }
  }
}
</style>
